import axios from "axios";
import { buildAuthHeaders } from "../buildAuthHeaders";

export type AccountSessionResponse = {
  clientSecret: string;
};

const endpoint = `/client/account-session`;

export const postCreateAccountSession = async (
  accessToken: string,
  rootUrl: string
): Promise<AccountSessionResponse> => {
  const { data } = await axios.post<AccountSessionResponse>(
    `${rootUrl}${endpoint}`,
    {},
    buildAuthHeaders(accessToken)
  );
  return data;
};
